import { ErrorFallbackProps, ErrorFallbackBase } from './ErrorFallbackBase';

// Niveau 2 (PublicErrorBoundary) : erreur de zone, navigation perdue
export const LayoutErrorFallback = (props: ErrorFallbackProps) => (
  <ErrorFallbackBase {...props} showDebugDetails />
);
